// extracted by mini-css-extract-plugin
export default {"history_container":"History_history_container__s40Ez"};